<ng-container *ngIf="isMultiCartActive; else shopCart">
  <app-multi-cart
      [isExportCartActive]="isExportCartActive">
  </app-multi-cart>
</ng-container>
<ng-template #shopCart>
  <app-shop-cart
      [isExportCartActive]="isExportCartActive">
  </app-shop-cart>
</ng-template>
